import { memo } from 'react';
import { PreferenceOption } from '@mark43/cad-api';
import { Text, VStack } from '@cad-arc';
import { FormBooleanRadioGroup } from '../forms/integrated-form-controls/form-boolean-radio-group';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { PreferencesFormType } from './types';
import { DEFAULT_NARRATIVE_DIRECTION_NEW_ON_TOP } from './constants';

export const NarrativeDirectionPreference = memo(function NarrativeDirectionPreference({
    fields,
}: {
    fields: PreferenceOption[];
}) {
    const { form } = useIntegratedForm<PreferencesFormType>();

    const preferenceIndex = fields.findIndex(
        (f) => f.preference === DEFAULT_NARRATIVE_DIRECTION_NEW_ON_TOP
    );

    if (preferenceIndex === -1) {
        return null;
    }

    return (
        <VStack
            alignItems="flex-start"
            data-testid="narrative-direction-preference"
            marginTop="3"
            spacing="1"
        >
            <Text fontSize="sm" color="tertiary" as="b">
                Default narrative layout direction
            </Text>
            <FormBooleanRadioGroup
                name={`preferences.${preferenceIndex}.value`}
                items={[
                    { label: 'New messages on top', value: true },
                    { label: 'New messages on bottom', value: false },
                ]}
                control={form.control}
                radioGroupProps={{ direction: 'column' }}
            />
        </VStack>
    );
});
